import React, { useState } from 'react';
import FileUploadTemplate from '@/components/common/FileUpload/FileUploadTemplate';
import { useProduct } from '../../../context/productContext/ProductContextProvider.jsx';

const NewItemCondition = () => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const { uploadProductCondtitionFile } = useProduct();

  const handleFilesSelected = (files) => {
    if (files.length !== 1) {
      alert('Please upload exactly one file.');
      return;
    }
    setSelectedFiles(files);
  };

  const handleUpload = async (files) => {
    if (files.length === 1) {
      await uploadProductCondtitionFile(files[0]);
      setSelectedFiles([]); // Clear selected files after successful upload
    } else {
      alert('Please select a file to upload.');
    }
  };

  return (
    <div>
      <div>
        <h2 className="text-2xl font-semibold text-gray-800 mb-4"></h2>
        <p className="text-gray-500 mb-6 text-center">
          Please upload a CSV file containing product data.
        </p>

        <FileUploadTemplate
          acceptedFileTypes={['.csv']}
          onFilesSelected={handleFilesSelected}
          multiple={false}
          onUpload={handleUpload}
          maxFiles={1}
        />
      </div>
      <div className="overflow-x-auto rounded-lg bg-gray-50 shadow-sm">
        <table className="min-w-full divide-y divide-gray-200 text-sm text-gray-700">
          <thead className="bg-gray-100">
            <tr>
              <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                Item Code
              </th>
              <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                Condition{' '}
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {/* Sample Row */}
            <tr>
              <td className="py-2 px-4 text-center">XY0121</td>
              <td className="py-2 px-4 text-center">A</td>
            </tr>
            {/* Additional rows can be added here */}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default NewItemCondition;
